import _ from 'lodash';

export function scrollToElement(id){
    if(id===undefined || id===null) id = "header";
    const element = document.getElementById(id);
    
    if(element!==undefined && element!==null){
        var elemRect = element.getBoundingClientRect();
        var bodyRect = document.body.getBoundingClientRect();
        let gotoTop = elemRect.top - bodyRect.top - 90;
        
        element.scrollIntoView({ behavior: 'smooth', block:'start' });
        _.delay(()=>{
            // gnb 때문에 조금더 올려줌
            window.scrollTo(0, gotoTop)
        }, 500);
    }
}
